// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__3DL4r","info":"PatientInfo_info__NCJhm"};